module.exports = __webpack_public_path__ + "img/pretty-bear.c2b09e69.jpg";